import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSegment } from '@sparknz/journeys-common';

import { useProductDetails } from 'journey/productDetails/provider';
import { WearableEligibilityCheckSteps } from 'journey/productDetails/typings';
import { trackLinkedProductsEvent } from 'journey/productDetails/utils';
import { extractFirstValue } from 'shared/utils';

const ELIGIBILITY_SELECTOR_TYPES = {
  account: 'Account',
  line: 'Line',
};

export default function useTrackEligibilitySelector() {
  const router = useRouter();
  const { isBusiness } = useSegment();
  const { paymentOptions, selectedDevice, wearableEligibility } =
    useProductDetails();

  const ifpId = extractFirstValue(router.query.ifpId);

  const showEligibilityAccountSelector =
    wearableEligibility.activeStep ===
    WearableEligibilityCheckSteps.AccountSelection;

  const showEligibilityLineSelector =
    wearableEligibility.activeStep ===
    WearableEligibilityCheckSteps.LineSelection;

  useEffect(() => {
    if (showEligibilityAccountSelector || showEligibilityLineSelector) {
      const selectorType = showEligibilityAccountSelector
        ? ELIGIBILITY_SELECTOR_TYPES.account
        : ELIGIBILITY_SELECTOR_TYPES.line;

      trackLinkedProductsEvent({
        eventInfo: {
          eventName: `Wearable Plan Selector ${selectorType} View`,
          eventAction: `shop.wearablePlanSelector.${selectorType.toLowerCase()}.view`,
        },
        device: selectedDevice,
        isBusiness,
        paymentOption: paymentOptions?.find(({ id }) => id === ifpId),
      });
    }
  }, [
    selectedDevice,
    isBusiness,
    showEligibilityAccountSelector,
    showEligibilityLineSelector,
  ]);
}
